export default {
  isLogin (state) {
    return Boolean(state.token)
  },
  bookingRemind ({ bindTicket }) {
    return bindTicket ? bindTicket.bookingRemind : ''
  }
}
